import { MaskedLine } from "./Reveal";

export default function PageHeader({ eyebrow, title, description }) {
  return (
    <section className="relative bg-forest-dark grain overflow-hidden" data-testid="page-header">
      <svg
        viewBox="0 0 24 24"
        className="absolute -right-10 -bottom-16 w-80 h-80 text-sand/[0.04]"
        fill="none"
        stroke="currentColor"
        strokeWidth="1"
        aria-hidden="true"
      >
        <path d="M12 2C7 7 4.5 11.5 4.5 15a7.5 7.5 0 0015 0c0-3.5-2.5-8-7.5-13z" />
        <path d="M12 8v13" />
      </svg>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 pt-36 pb-16 lg:pt-44 lg:pb-24">
        {eyebrow && <span className="eyebrow text-moss">{eyebrow}</span>}
        <h1 className="mt-4 font-serif text-4xl sm:text-5xl lg:text-6xl font-medium tracking-tight text-sand leading-[1.08]">
          <MaskedLine delay={0.1}>{title}</MaskedLine>
        </h1>
        {description && (
          <p className="mt-5 max-w-2xl text-base sm:text-lg text-sand/70 font-light leading-relaxed">{description}</p>
        )}
      </div>
    </section>
  );
}
